import { Create, DateInput, DateTimeInput, FormDataConsumer, SelectInput, SimpleForm, TextInput, required } from "react-admin";
import { RichTextInput } from 'ra-input-rich-text';
import {FileInput} from "../fileinputs/eventFileUpload";
import { MyRichTextInput } from "./utils";



export function EventCreate(props) {


    return (
        <Create>
            <SimpleForm>
                <TextInput source="name" validate={required()} />
                {/* <TextInput source="description" /> */}

                <MyRichTextInput source="description" />
                <TextInput source="textDescription" multiline />


                <SelectInput source="type" choices={[
                    { id: "online", name: "Online" },
                    { id: "offline", name: "Offline" },
                ]} validate={required()} />
                <TextInput source="city" validate={required()} />
                {/* <TextInput source="location"  /> */}

                <FormDataConsumer>
                    {({ formData, ...rest }) => <TextInput source="location" {...rest} label={formData.type === 'offline' ? 'Location Link' : 'Meeting Link'} />}
                </FormDataConsumer>
                <TextInput source="externalLink"  type="url"/>
                <DateTimeInput source='startDate' validate={required()} />
                <DateTimeInput source='endDate'  />
                <FileInput source="images" add edit />

            </SimpleForm>

        </Create>
    );
}